import React, { memo } from "react";
import locale from "./blankPanel.locale";
function BlankPanel({ button }) {
    return (React.createElement("div", { className: "flex-box-centered-content d-flex-column" },
        React.createElement("div", { className: "text-light-on-surface-variant text-center line-height-small unselectable pt-0_5 pb-1" }, locale.NO_DATA),
        button));
}
export default memo(BlankPanel);
